<template>
  <div>
    <v-hover
      v-slot:default="{ hover }"
      :disabled="restrictPlaylistAccess">
      <v-list-item
        class="mt-n2 mb-n3">
        <v-list-item-icon
          class="ml-n2 mr-3">
          <v-icon>mdi-card-text-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle
            class="text-left">
            {{ moduleText.text.title }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action
          v-if="hover && !showSlideout">
          <v-icon @click="handleEditText">mdi-settings</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-hover>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  name: 'DraggableText',
  props: {
    moduleText: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'isUpdating',
      'passbackBulbs',
      'showSlideout',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
  },
  methods: {
    ...mapActions([
      'updateResourceName',
    ]),
    ...mapMutations([
      'setSlideout',
    ]),
    handleEditText() {
      this.setSlideout({
        type: 'textEditor',
        data: this.moduleText,
      });
    },
  },
};
</script>
